import React from "react";
import { Box, Typography } from "@mui/joy";

type Step = {
    label?: string;
    Name?: string;
};

type ProgressStepperProps = {
    steps: Step[];
    currentStep: number; // 0-based index
    onClick: any;
    radius?: number;
};

const stepperHeight = 37;

const ProgressStepper: React.FC<ProgressStepperProps> = ({ steps, currentStep, onClick, radius = 30 }) => {
    return (
        <Box
            sx={{
                display: "flex",
                width: "100%",
                backgroundColor: "background.surface",
                borderRadius: `${radius}px`,
                overflow: "hidden",
                gap: 2,
            }}
        >
            {steps.map((step, index) => {
                const isCompleted = index < currentStep;
                const isCurrent = index === currentStep;

                return (
                    <Box
                        key={step.label || step.Name}
                        onClick={() => onClick(step)}
                        sx={(palette: any) => ({
                            flex: 1,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            //pl: index===0 ? 2: 1,
                            //color: isCompleted ? '#fff' : 'text.primary',
                            backgroundColor: isCompleted ? "#4CAF50" : isCurrent ? "#3e4e50" : "background.level2",
                            height: stepperHeight,
                            "&::after": {
                                content: '""',
                                position: "absolute",
                                bottom: "0",
                                left: "-.25rem",
                                right: "-.3125rem",
                                backgroundColor: isCompleted ? "#4CAF50" : isCurrent ? "#3e4e50" : "background.level2",
                                height: stepperHeight / 2,
                                transform: "skew(-30deg) translate3d(0, 0, 0)",
                            },
                            "&::before": {
                                content: '""',
                                position: "absolute",
                                top: "0",
                                left: "-.25rem",
                                right: "-.3125rem",
                                backgroundColor: isCompleted ? "#4CAF50" : isCurrent ? "#3e4e50" : "background.level2",
                                height: stepperHeight / 2,
                                transform: "skew(28deg) translate3d(0, 0, 0)",
                            },
                            border:
                                isCompleted || isCurrent
                                    ? "none"
                                    : "1px solid var(--joy-palette-neutral-outlinedBorder)",
                        })}
                    >
                        <Typography
                            level="body-sm"
                            sx={{
                                zIndex: 1002,
                                fontWeight: 500,
                                color: isCurrent ? "white" : isCompleted ? "white" : "text.primary",
                            }}
                        >
                            {step.label || step.Name}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};

export default ProgressStepper;
